<template>
  <section>
    <!-- <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'session'"></ContentLoader>
    </div> -->
    <!-- v-else -->
    <div>
      <div
        v-if="d.entity_type == 2"
        class="bg-white border-1 border-borderColor min-h-full rounded-lg duration-500 shadow-all flex flex-col w-full"
      >
        <div class="relative">
          <img
            class="object-cover rounded-t-lg w-full h-48"
            :src="baseUrlSrc(d.thumbnail_url)"
            alt="..."
            v-bind:class="{ 'h-32': userTrainerSize, 'h-48': !userTrainerSize }"
            @error="defaultImage"
          />
          <div class="flex justify-end -mt-10 mr-2">
            <span
              class="font-medium md:text-base text-white session-card-cost-container rounded-lg flex justify-center"
            >
            {{ d.cost && d.cost > 0 ? `$ ${d.cost}` :  "Free" }}
            </span>
          </div>
          <div v-if="paymentStatus">
            <div
              class="absolute top-0 right-0 text-white bg-red-500 px-2 m-2 rounded"
              @mouseover="isPaymentTextOpen = true"
              @mouseleave="isPaymentTextOpen = false"
              v-if="d.payment_status == PAYMENT_PENDING"
            >
              <div class="flex items-center" v-if="isPaymentTextOpen">
                <p class="py-1 text-sm">
                  Payment Pending <span class="ml-2">!</span>
                </p>
              </div>
              <div v-else>
                <p class="px-1 py-1 text-sm">!</p>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-2 pb-4 px-3 mt-4">
          <div class="items-center">
            <h4 class="text-base font-semibold text-blackgrey capitalize mb-1 text-ellipses"
              v-bind:class="{
                'text-base': !userTrainerSize,
                'text-lg': userTrainerSize,
              }"
            >
              {{ handleStr(d.title, 25) }}
            </h4>
            <div class="mb-2 w-full flex justify-between">
              <div>
                <p
                  v-if="isTrainerName"
                  class="text-ellipses max-width-60 capitalize text-blackgreylight text-sm"
                >
                  By {{ d.trainer_name || "Trainer Name" }}
                </p>
                <span v-if="isTrainerName" class="mx-1">|</span>

                <p class="capitalize text-ellipse text-blackgreylight text-sm">
                  {{ d.level || d.difficulty_name || d.difficulty_type }}
                </p>
              </div>
              <div class="flex items-center space-x-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                <p class="pl-1 capitalize text-blackgreylight text-sm">
                  {{ d.no_of_sessions }}
                  {{ d.no_of_sessions > 1 ? "Sessions" : "Session" }}
                </p>
              </div>
            </div>
            <div class="flex items-center mb-2">
              <Rating :data="d.avg_rating" />

              <p class="text-xs ml-1">
                <span class="text-gray-dark">
                  {{ d.avg_rating ? d.avg_rating : "0" }}
                </span>
                <span class="text-blackgreylight">({{ d.total_reviews }})</span>
              </p>
            </div>
          </div>
          <!-- formatDateTime -->
          <div
            class="text-gray-800 text-xs w-max flex flex-col xl:flex xl:flex-row xl:justify-between mt-4"
            v-if="entityType == USER"
          >
            <div
              class="ring-1 date-time-container-custom-width ring-gray-400 px-1 py-1 rounded-lg flex justify-center items-center"
            >
              {{
                handleMonthDateTime(d.start_date, "time") +
                " - " +
                handleHour12(d.end_date)
              }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="bg-white border-1 border-borderColor min-h-full rounded-lg duration-500 shadow-all flex flex-col w-full"
      >
        <div class="relative">
          <img
            class="object-cover rounded-t-lg w-full h-48"
            :src="baseUrlSrc(d.thumbnail_url)"
            alt="..."
            v-bind:class="{ 'h-32': userTrainerSize, 'h-48': !userTrainerSize }"
            @error="defaultImage"
          />
          <div class="flex justify-end -mt-10 mr-2">
            <span
              class="font-medium md:text-base text-white session-card-cost-container rounded-lg flex justify-center"
            >
              {{ d.cost && d.cost > 0 ? `$ ${d.cost}` :  "Free" }}
            </span>
          </div>
          <div v-if="paymentStatus">
            <div
              class="absolute top-0 right-0 text-white bg-red-500 px-2 m-2 rounded"
              @mouseover="isPaymentTextOpen = true"
              @mouseleave="isPaymentTextOpen = false"
              v-if="d.payment_status == PAYMENT_PENDING"
            >
              <div class="flex items-center" v-if="isPaymentTextOpen">
                <p class="py-1 text-sm">
                  Payment Pending <span class="ml-2">!</span>
                </p>
              </div>
              <div v-else>
                <p class="px-1 py-1 text-sm">!</p>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-2 pb-4 px-3 mt-4">
          <div class="items-center">
            <h4 class="text-base font-semibold text-blackgrey capitalize mb-1 text-ellipses w-full"
              v-bind:class="{
                'text-base': !userTrainerSize,
                'text-lg': userTrainerSize,
              }"
            >
              {{ handleStr(d.title, 22) }}
            </h4>
           
            <div class="mb-2 w-full flex justify-between pb-1">
              <p
                class="text-ellipses max-width-60 capitalize text-blackgreylight text-sm"
                v-if="isTrainerName"
              >
                By {{ d.trainer_name || "Trainer Name" }}
              </p>
              <span v-if="isTrainerName" class="mx-1">|</span>
              <p class="capitalize text-ellipse text-blackgreylight text-sm">
                {{ d.level || d.difficulty_name || d.difficulty_type }}
              </p>
            </div>

            <div class="flex items-center mb-2">
              <Rating :data="d.avg_rating" />
              <p class="text-xs ml-1">
                <span class="text-gray-dark">{{
                  d.avg_rating ? d.avg_rating : "0"
                }}</span>
                <span class="text-blackgreylight">({{ d.total_reviews }})</span>
              </p>
            </div>

          </div>
          <div
            class="text-blackgreylight text-xs w-max flex flex-col xl:flex xl:flex-row xl:justify-between mt-4"
            v-if="entityType == USER"
          >
            <div
              class="ring-1 date-time-container-custom-width ring-gray-400 px-1 py-1 rounded-lg flex justify-center items-center"
            >
              {{
                handleMonthDateTime(d.start_date, "time") +
                " - " +
                handleHour12(d.end_date)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="statusCode == 404">
      <p>No data found.</p>
    </div>
  </section>
</template>
<script>
// import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { Rating } from "@/components/t-components";

export default {
  name: "CourseSessionListingCard",
  components: {
    // ContentLoader,
    Rating,
  },
  props: {
    d: {
      type: Object,
    },
    isTrainerName: {
      type: Boolean,
      default: true,
    },
    paymentStatus: {
      type: Boolean,
      default: false,
    },
    statusCode: {
      type: Number,
    },
    entityType: {
      type: Number,
    },
    userTrainerSize: {
      type: Boolean,
    },
  },
  // computed: {
  //   loadingStatus() {
  //     return this.$store.getters.loadingStatus;
  //   },
  // },
  data() {
    return {
      isPaymentTextOpen: false,
      PAYMENT_PENDING: 2,
    };
  },
};
</script>

<style scoped>
.session-card-cost-container {
  background-color: rgba(0, 0, 0, 0.3);
  min-width: 3.625rem;
  padding: 0.2rem 0.688rem;
}
@media only screen and (min-width: 1025px) {
  .date-time-container-custom-width {
    width: 13rem;
  }
}
.max-width-60 {
  max-width: 60%;
}
</style>